// extracted by mini-css-extract-plugin
export default {"root":"ui__shared__right-content-menu__sub-block-list__root","subBlockItem":"ui__shared__right-content-menu__sub-block-list__subBlockItem"};